<template>
  <el-table-column prop="views" label="Views" width="70" header-align="center">
    <template #default="scope">
      <el-tooltip
        :content="fetchTooltipContent(scope.index, scope.row.viewTimestamps)"
        placement="top"
        raw-content
        @mouseenter.native="activateTooltip(scope.index)"
        @mouseleave.native="deactivateTooltip"
      >
        <div
          class="text-center large-font-column"
          @mouseenter="activateTooltip(scope.index)"
          @mouseleave="deactivateTooltip"
        >
          {{ scope.row.views }}
        </div>
      </el-tooltip>
    </template>
  </el-table-column>
</template>

<script setup>
import { ref } from "vue";

const activeTooltip = ref(null);

const activateTooltip = (index) => {
  activeTooltip.value = index;
};

const deactivateTooltip = () => {
  activeTooltip.value = null;
};

const fetchTooltipContent = (index, timestamps) => {
  if (index === activeTooltip.value) {
    return humanizeTimestamps(timestamps);
  }
};

const humanizeTimestamps = (timestamps) => {
  if (!timestamps) {
    return "No recorded Timestamps";
  }
  return timestamps
    .map((nestedArray) => new Date(nestedArray[0]).toString())
    .join("<br>");
};
</script>

<style scoped>
.large-font-column {
  font-size: 24px;
}
</style>
